import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cn } from '../helpers/index.js'
import { type VariantProps, cva } from 'class-variance-authority'
import type { ComponentPropsWithout, RemovedProps } from '../helpers/component-props.js'
const colorVariants = cva('', {
  variants: {
    color: {
      brand0: 'bg-brand-0',
      brand1: 'bg-brand-1',
      success0: 'bg-success-0',
      success1: 'bg-success-1',

      warning0: 'bg-warning-0',
      warning1: 'bg-warning-1',

      error0: 'bg-error-0',
      error1: 'bg-error-1',

      infoPrimary: 'bg-info-primary',
      infoSecondary: 'bg-info-secondary',
      infoTertiary: 'bg-info-tertiary',
      infoQuaternary: 'bg-info-quaternary',
      infoWhite: 'bg-info-white',

      containerPrimary: 'bg-container-primary',
      containerSecondary0: 'bg-container-secondary-0',
      containerSecondary1: 'bg-container-secondary-1',

      bg0: 'bg-bg-0',
      bg1: 'bg-bg-1',
      lines: 'bg-lines',
      masks0: 'bg-masks-0',
      masks1: 'bg-masks-1',
    },
  },
  defaultVariants: {
    color: 'brand0',
  },
})
type ColorElement = React.ElementRef<'div'>
type ColorDivProps = ComponentPropsWithout<'div', RemovedProps>
interface CommonColorProps extends VariantProps<typeof colorVariants> {}
type ColorProps = CommonColorProps & ColorDivProps

/**
 * Color - 颜色容器
 *
 * @description 提供主题色彩配置的容器组件，支持品牌色、状态色等多种预设颜色
 * @deprecated 已作废，请使用 默认的配色 或 直接设置颜色
 */
const Color = React.forwardRef<ColorElement, ColorProps>((props, forwardedRef) => {
  const { children, color = 'brand0', className, ...colorProps } = props
  return (
    <Slot
      {...colorProps}
      ref={forwardedRef}
      className={cn(
        colorVariants({
          color,
        }),
        className
      )}
    >
      {children}
    </Slot>
  )
})
Color.displayName = 'Color'
export { Color }
export type { ColorProps }
